<script>
import Vue from 'vue';
import {mapState, mapActions, mapGetters} from 'vuex';
import ContractFormSite from '../ContractFormSite/ContractFormSite.vue';
import ContractFormTerms from '../ContractFormTerms/ContractFormTerms.vue';
import ContractFormPrice from '../ContractFormPrice/ContractFormPrice.vue';
import ContractFormExtra from '../ContractFormExtra/ContractFormExtra.vue';
import ContractFormArrival from '../ContractFormArrival/ContractFormArrival.vue';
import ContractFormDiscount from '../ContractFormDiscount/ContractFormDiscount.vue';
import ContractFormAllocation from '../ContractFormAllocation/ContractFormAllocation.vue';
import ContractFormAccommodation from '../ContractFormAccommodation/ContractFormAccommodation.vue';
import ContractFormSupplierInfo from '../ContractFormSupplierInfo/ContractFormSupplierInfo.vue';
import ContractFormCancellationRules from '../ContractFormCancellationRules/ContractFormCancellationRules.vue';

export default Vue.extend({
    components: {
        ContractFormSite,
        ContractFormPrice,
        ContractFormTerms,
        ContractFormExtra,
        ContractFormArrival,
        ContractFormDiscount,
        ContractFormAllocation,
        ContractFormAccommodation,
        ContractFormSupplierInfo,
        ContractFormCancellationRules,
    },
    computed: {
        ...mapState({
            history: state => state.contract.history.items,
            contract: state => state.contract.contract.item,
            part: state => state.contract.contract.part,
            progress: state => state.contract.contract.progress.item,
            loading: state => state.contract.contract.form.accept.loading
        }),
        ...mapGetters({
            userCanAccept: 'contract/userCanAccept'
        })
    },
    methods: {
        ...mapActions({
            contractPartAccept: 'contract/contractPartAccept',
        })
    }
});
</script>
<template>
    <div class="contract-form">
        <div class="contract-form__content">
            <div v-if="contract.status === 'initiated'" class="contract-form__message">
                <div class="contract-form__message-icon">
                    <i class="fa fa-info"/>
                </div>
                <div class="contract-form__message-text">
                    {{ $t('contract.form.message.' + contract.status) }}
                </div>
            </div>
            <div class="contract-form__form">
                <contract-form-supplier-info v-if="part === 'supplierInfo'"/>
                <contract-form-site v-if="part === 'sites'"/>
                <contract-form-price v-if="part === 'prices'"/>
                <contract-form-extra v-if="part === 'extras'"/>
                <contract-form-arrival v-if="part === 'arrivalRules'"/>
                <contract-form-cancellation-rules v-if="part === 'cancellationRules'"/>
                <contract-form-discount v-if="part ==='discounts'"/>
                <contract-form-allocation v-if="part ==='allocations'"/>
                <contract-form-accommodation v-if="part === 'accommodations'"/>
                <contract-form-terms v-if="part === 'terms'"/>
            </div>
            <div class="contract-form__control">
                <button v-if="userCanAccept" :disabled="progress[part]"
                        class="contract-form__accept-btn"
                        @click="contractPartAccept(part)">
                    <span v-if="!progress[part]">
                        {{ $t('contract.form.acceptPart') }} {{ $t('contract.form.progress.part.' + part) }}
                    </span>
                    <span v-if="progress[part]">
                        {{ $t('contract.form.progress.part.' + part) }} {{ $t('contract.form.partAccepted') }}
                    </span>
                </button>
            </div>
        </div>
    </div>
</template>



// WEBPACK FOOTER //
// src/components/ContractForm/ContractForm.vue